import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from './environments/environment';
import { AppModule } from './app/app.module';
import { LoggingService } from '@core/services/logging.service';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(async (moduleRef) => {
    const logger = moduleRef.injector.get(LoggingService);
    await logger.writeLog('[bootstrap] Initializing FreshAi Web Application', {
      severity: 'NOTICE',
    });
    (window as any).isHealthy = true;

    // --- Minimal tripwires for lazy-chunk failures ---
    const markUnhealthy = (msg: unknown) => {
      const s = String((msg as any)?.message ?? msg ?? '');
      if (
        /(ChunkLoadError|Loading chunk \d+ failed|Failed to fetch dynamically imported module|Importing a module script failed|disallowed MIME type)/i.test(
          s,
        )
      ) {
        (window as any).isHealthy = false;
      }
    };

    // Dynamic import / router lazy-load failures surface here
    window.addEventListener('unhandledrejection', (ev) => markUnhealthy(ev.reason));

    // Some browsers surface module/script load issues as window "error"
    window.addEventListener(
      'error',
      (ev: Event) => {
        markUnhealthy((ev as any).message ?? ev);
      },
      true,
    );
  })
  // eslint-disable-next-line no-console
  .catch((err) => console.error(err));
